<template>
  <div style="margin-top:67px">
    <div class="desktop">
      <section class="main-banners">
        <div class="main-container switcher hidden" v-bind:class="{show: isShowSwitcher}">
          <div id="switcher">
            <h1>Switcher</h1>
            <p>누워서 불을 끄는 가장 심플한 방법</p>
            <button id="goSwitcher" @click="goSwitcher">무료체험하기</button>
          </div>
        </div>
        <div class="main-container linker hidden" v-bind:class="{show: isShowLinker}">
          <div id="linker">
            <h1>Linker</h1>
            <p>에어컨, TV 이제는 스마트폰으로 켜고 끄세요</p>
            <button id="goLinker" @click="goLinker">무료체험하기</button>
          </div>
        </div>
        <div class="main-container checker hidden" v-bind:class="{show: isShowChecker}">
          <div id="checker">
            <h1>Checker</h1>
            <p>우리 집 도어 가드</p>
            <button id="goChecker" @click="goChecker">무료체험하기</button>
          </div>
        </div>
        <div class="main-container free-trial">
          <div id="try">
            <h1>Try it for free</h1>
            <p>한 달간 무료로 체험해보세요</p>
            <router-link :to="{ name: 'FreeTrial' }" id="goFreetrial">
              <button>알아보기</button>
            </router-link>
          </div>
          <div id="airbnb">
            <h1>Mall</h1>
            <p>
              아이오 온라인공식몰에서
              <br>스마트홈을 시작해보세요
            </p>
            <a href="https://smartstore.naver.com/ioswitcher" target="_blank">
              <button id="goAirbnb">보러하기</button>
            </a>
          </div>
          <div id="campaign" class="hidden">
            <h1>Campaign</h1>
            <p>
              방범을 위한 기부 캠페인에
              <br>참여하세요
            </p>
            <router-link :to="{ name: 'Campaign' }">
              <button>알아보기</button>
            </router-link>
          </div>
        </div>
      </section>
    </div>
    <div class="mobile">
      <section class="hidden" id="m-switcher" v-bind:class="{show: isShowSwitcher}">
        <h1>Switcher</h1>
        <p>누워서 불을 끄는 가장 심플한 방법</p>
        <button id="goSwitcher" @click="goSwitcher">무료체험하기</button>
      </section>
      <section class="hidden" id="m-linker" v-bind:class="{show: isShowLinker}">
        <h1>Linker</h1>
        <p>에어컨, TV 이제는 스마트폰으로 켜고 끄세요</p>
        <button id="goLinker" @click="goLinker">무료체험하기</button>
      </section>
      <section class="hidden" id="m-checker" v-bind:class="{show: isShowChecker}">
        <h1>Checker</h1>
        <p>우리 집 도어 가드</p>
        <button id="goChecker" @click="goChecker">무료체험하기</button>
      </section>
      <section id="m-airbnb">
        <h1>Mall</h1>
        <p>
          아이오 온라인공식몰에서 스마트홈을 시작해보세요
        </p>
        <a href="https://smartstore.naver.com/ioswitcher" target="_blank">
          <button id="goAirbnb">보러가기</button>
        </a>
      </section>
      <section id="m-try" class="hidden">
        <h1>Try it for free</h1>
        <p>한 달간 무료로 체험해보세요</p>
        <router-link :to="{ name: 'FreeTrial' }" id="goFreetrial">
          <button>알아보기</button>
        </router-link>
      </section>
      <section id="m-campaign" class="hidden">
        <h1>Campaign</h1>
        <p>
          방범을 위한 기부 캠페인에
          <br>참여하세오
        </p>
        <router-link :to="{ name: 'Campaign' }">
          <button>알아보기</button>
        </router-link>
      </section>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import AppFooter from '.././../components/AppFooter'
  import { IO_PRODUCTS } from '../../modules/products'

  export default {
    name: 'main',
    components: { AppFooter },
    data () {
      return {
        isShowSwitcher: false,
        isShowLinker: false,
        isShowChecker: false
      }
    },
    computed: {
      numberOfCartItems () {
        return this.$store.state.numberOfCartItems
      }
    },
    created () {
      this.showRandomProduct(
        this.randomRange(IO_PRODUCTS.SWITCHER_TWO_BUTTON, IO_PRODUCTS.CHECKER)
      )
    },
    mounted () {
      if (this.numberOfCartItems === 0) {
        this.$store.commit('initApplicantData')
      }
    },
    beforeDestroy () {
      this.isShowSwitcher = false
      this.isShowLinker = false
      this.isShowChecker = false
    },
    methods: {
      goSwitcher: function () {
        this.$router.push({ name: 'Switcher' })
      },
      goLinker: function () {
        this.$router.push({ name: 'Linker' })
      },
      goChecker: function () {
        this.$router.push({ name: 'Checker' })
      },
      randomRange: function (n1, n2) {
        return Math.floor(Math.random() * (n2 - n1 + 1) + n1)
      },
      showRandomProduct: function (number) {
        switch (number) {
          case IO_PRODUCTS.SWITCHER_TWO_BUTTON:
            this.isShowSwitcher = true
            break
          case IO_PRODUCTS.LINKER:
            this.isShowLinker = true
            break
          case IO_PRODUCTS.CHECKER:
            this.isShowChecker = true
            break
          default:
            this.isShowSwitcher = true
        }
      }
    }
  }
</script>
<style scoped>
.hidden {
  display: none;
}
.show {
  display: block;
}

.free-trial {
  display: flex;
  flex-direction: column;
}
.main-banners {
  display: flex;
}

.main-banners h1 {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -0.3px;
}

.main-banners p {
  font-size: 20px;
  letter-spacing: 0;
}

.main-banners button {
  font-size: 15px;
  margin-top: 10px;
  width: 100px;
  height: 39px;
  font-weight: 500;
  text-decoration: none;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
  border: 0;
  color: #3d4953;
}
.main-banners button:hover {
  background-color: #ffffff;
}
.main-container {
  flex: 1;
}

#switcher {
  background: url("../../assets/main/con-switcher.png") no-repeat center center;
  background-size: cover;
  height: calc(100vh - 56px);
  padding: 100px;
  text-align: left;
}

#linker {
  background: url("../../assets/main/con-linker.png") no-repeat center center;
  background-size: cover;
  height: calc(100vh - 56px);
  padding: 100px;
  text-align: left;
}

#try {
  background: url("../../assets/main/con-try.png") no-repeat center bottom;
  background-size: cover;
  height: calc(50vh - 28px);
  padding: 100px;
  text-align: left;
}

#checker {
  background: url("../../assets/main/con-checker.png") no-repeat center bottom;
  background-size: cover;
  height: calc(100vh - 56px);
  padding: 100px;
  text-align: left;
}

#airbnb {
  background-image: url("../../assets/main/con-airbnb.png");
  background-size: 100% 100%;
  height: calc(50vh - 28px);
  padding: 100px;
  text-align: left;
  color: #3d4953;
}
#campaign {
  background-image: url("../../assets/main/con-campaign.png");
  background-size: 100% 100%;
  height: calc(50vh - 28px);
  padding: 100px;
  text-align: left;
  color: #ffffff;
}

#m-switcher {
  background: url("../../assets/main/m-switcher.png") no-repeat center center;
  background-size: cover;
  min-height: 473px;
  padding: 60px 25px 25px 25px;
  text-align: left;
}

#m-linker {
  background: url("../../assets/main/m-linker.png") no-repeat center bottom;
  background-size: cover;
  min-height: 473px;
  padding: 60px 25px 25px 25px;
  text-align: left;
}

#m-checker {
  background: url("../../assets/main/m-checker.png") no-repeat center bottom;
  background-size: cover;
  min-height: 473px;
  padding: 60px 25px 25px 25px;
  text-align: left;
}

#m-try {
  background: url("../../assets/main/m-try.png") no-repeat center center;
  background-size: cover;
  min-height: 473px;
  padding: 60px 25px 25px 25px;
  text-align: left;
}

#m-airbnb {
  background-image: url("../../assets/main/m-airbnb.png");
  background-size: cover;
  min-height: 473px;
  padding: 60px 25px 25px 25px;
  text-align: left;
}
#m-campaign {
  background-image: url("../../assets/main/m-campaign.png");
  background-size: cover;
  min-height: 473px;
  padding: 60px 25px 25px 25px;
  text-align: left;
  color: #ffffff;
}

.mobile h1 {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: -0.3px;
}

.mobile p {
  font-size: 14px;
  letter-spacing: 0;
}
.mobile button {
  font-size: 14px;
  margin-top: 10px;
  width: 110px;
  height: 39px;
  text-decoration: none;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
  border: 0;
  color: #3d4953;
}

.main-banners button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Main.vue